import { render, staticRenderFns } from "./MainLifeInfoWidget.vue?vue&type=template&id=4a11b10f&scoped=true"
import script from "./MainLifeInfoWidget.vue?vue&type=script&lang=js"
export * from "./MainLifeInfoWidget.vue?vue&type=script&lang=js"
import style0 from "./MainLifeInfoWidget.vue?vue&type=style&index=0&id=4a11b10f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a11b10f",
  null
  
)

/* custom blocks */
import block0 from "./MainLifeInfoWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports